import Vue from 'vue'
import Vuex from 'vuex'
//挂载Vuex
Vue.use(Vuex)

/*state => 基本数据
getters => 从基本数据派生的数据
mutations => 提交更改数据的方法，同步！
actions => 像一个装饰器，包裹mutations，使之可以异步。
modules => 模块化Vuex*/

import login from './login'
import common from "./common";
import attestation from "./attestation";
import system from "./system";
import file from "./file";
import record from "./record";
import banner from "./banner";
import dataBoard from "./dataBoard";


const debug = process.env.NODE_ENV !== 'production';
// 不要在发布环境下启用严格模式！严格模式会深度监测状态树来检测不合规的状态变更——请确保在发布环境下关闭严格模式，以避免性能损失。

//创建VueX对象
const store = new Vuex.Store({
    strict: debug,
    modules: {
      ...login,
      ...common,
      ...attestation,
      ...system,
      ...file,
      ...record,
      ...banner,
      ...dataBoard,
    }
  })
;

export default store



// WEBPACK FOOTER //
// ./src/store/index.js